function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 8,
  r: 7.5,
  fill: "#858585"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.162 7.968h.667c.623 0 1.09-.123 1.4-.37.31-.246.463-.605.463-1.076 0-.475-.13-.826-.389-1.053-.259-.226-.666-.34-1.22-.34h-.921v2.839zM13.74 6.45c0 1.03-.322 1.816-.965 2.362-.643.545-1.557.818-2.743.818h-.87v2.386a1.015 1.015 0 01-2.028 0V4.482c0-.56.454-1.014 1.013-1.014h2.041c1.16 0 2.042.25 2.646.75.604.498.906 1.243.906 2.232z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#858585",
  fillRule: "nonzero",
  d: "M9.829 0a7.968 7.968 0 11-.93 15.882A7.969 7.969 0 118.898.054C9.204.018 9.514 0 9.828 0zm-.93.923l-.015.002a7.107 7.107 0 00.014 14.088A7.107 7.107 0 008.899.923zm3.489.415l.058.04a7.958 7.958 0 013.49 6.59 7.963 7.963 0 01-3.548 6.63 7.107 7.107 0 000-13.26zm-6.98 0l-.154.061a7.109 7.109 0 00.153 13.199 7.962 7.962 0 01-3.546-6.63c0-2.765 1.408-5.2 3.546-6.63zm4.42 13.735a.431.431 0 110 .863h-1.86a.431.431 0 010-.863zm-5.404-2.175a.431.431 0 01.001.863H2.901a.431.431 0 010-.863zm-1.71-2.444a.432.432 0 110 .862H1.193a.432.432 0 110-.862zm-.76-2.917a.43.43 0 110 .862H.431a.43.43 0 11.001-.862zM3.015 4.09a.431.431 0 010 .863H1.494a.431.431 0 010-.863z"
}));

function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16
  }, props), _ref);
}

export default SvgPoint;